<template>
  <div class="box-detail SupportHub">
    <div class="box-left">
      <div class="box-left-header">
        <!-- 导航注释 -->
        <!-- <div @click="$router.push({ path: '/SupportHubs' })" class="goBack c-position-static c-m-0">
          <i class="el-icon-arrow-left"></i>
          <span>任务批次列表</span>
        </div> -->

        <!-- <div class="c-m-r-10">
            <el-tag effect="plain" v-if="formData.settleState == 0">
              {{ formatSettleState(formData.settleState) }}
            </el-tag>
            <el-tag effect="dark" v-else-if="formData.settleState == 1">
              {{ formatSettleState(formData.settleState) }}
            </el-tag>
            <el-tag effect="dark" v-else-if="formData.settleState == 2" type="success">
              {{ formatSettleState(formData.settleState) }}
            </el-tag>
            <el-tag effect="dark" v-else-if="formData.settleState == 3" type="warning">
              {{ formatSettleState(formData.settleState) }}
            </el-tag>
            <el-tag effect="dark" v-else-if="formData.settleState == 4" type="danger">
              {{ formatSettleState(formData.settleState) }}
            </el-tag>
            <el-tag effect="dark" v-else-if="formData.settleState" type="info">
              {{ formatSettleState(formData.settleState) }}
            </el-tag>
          </div> -->
      </div>
      <div class="box-left-content">
        <!-- 
            任务对象 type
            0: 平台给服务商
            1: 雨虹给修链
            2: 修链给服务商
            3: 服务商给修链
            4: 修链给雨虹
            99: 推广大使
          -->
        <!-- 
             任务来源类型 sourceType
        1: 线索 lead
        2: 客户 contacts
        3: 工单 serviceAppointment
        4: 订单 order
        5: 质保 warranty
          -->
        <el-form
          :model="formData"
          :rules="rules"
          ref="formData"
          label-width="110px"
          label-position="left"
        >
          <el-form-item label="任务批次号">
            <span>{{ formData.num }}</span>
          </el-form-item>
          <el-form-item label="任务批次标题" prop="title">
            <el-input
              v-model="formData.title"
              :disabled="formData.settleState != 0 && formData.settleState != undefined"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="任务批次来源类型"
            prop="sourceType"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择'
            }"
          >
            <el-select
              v-model="formData.sourceType"
              clearable
              @change="
                formData.toId = '';
                filterConditionChange(true);
              "
              :disabled="formData.settleState != 0 && formData.settleState != undefined"
            >
              <template v-for="item in options.sourceType">
                <el-option :key="item.value" :label="item.label" :value="item.value"></el-option>
              </template>
            </el-select>
          </el-form-item>

          <el-form-item>
            <template slot="label">
              {{ formatSourceType(null, null, formData.sourceType) || '' }}创建日期
            </template>
            <el-date-picker
              v-model="formData.datetimerange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="任务批次开始时间"
              end-placeholder="任务批次结束时间"
              clearable
              @change="filterConditionChange(true)"
              :disabled="formData.settleState != 0 && formData.settleState != undefined"
            ></el-date-picker>
          </el-form-item>

          <!-- <el-form-item v-if="formData.sourceType == 3" label="任务明细状态" prop="settleItemState">
            <el-select
              v-model="formData.settleItemState"
              clearable
              @change="filterConditionChange(true)"
              :disabled="formData.settleState != 0 && formData.settleState != undefined"
            >
              <template v-for="item in options.settleItemState">
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="Number(item.value)"
                ></el-option>
              </template>
            </el-select>
          </el-form-item> -->

          <el-form-item label="备注" prop="note">
            <el-input
              type="textarea"
              :rows="2"
              v-model="formData.memo"
              :disabled="formData.settleState != 0 && formData.settleState != undefined"
            ></el-input>
          </el-form-item>
          <el-form-item label="执行客服" prop="userId">
            <el-select
              v-model="formData.userId"
              clearable
              :disabled="formData.settleState != 0 && formData.settleState != undefined"
            >
              <template v-for="item in options.users">
                <el-option :key="item.value" :label="item.name" :value="item.value"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <!-- 扩展字段 -->
          <c-form
            label-width="110px"
            :formData="formData"
            :fields="extFields"
            :options="options"
            ref="form"
          ></c-form>
        </el-form>
      </div>
      <!-- <div class="box-left-footer">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div> -->
    </div>
    <div class="box-center">
      <el-tabs
        v-model="activeTab"
        @tab-click="tabClick"
        style="height: 100%; display: flex; flex-direction: column"
      >
        <!-- <el-tab-pane label="工单" name="contract" v-if="formData.sourceType == 'serviceAppointment'">
          <div class="box-center-tool">
            <el-tag type="success" size="medium">
              共查询到
              <span class="c_blue">{{ contracts.fpi.data.length }}</span>
              条符合条件的数据，已选择
              <span class="c_blue">{{ contracts.selectedRows.length }}</span>
              条。
            </el-tag>
            <div>
              <el-button type="primary" @click="doSave()" class="c-m-l-10">
                保存选则的工单
              </el-button>
            </div>
          </div>
          <div class="box-center-content">
            <el-table
              v-if="formData.sourceType == 0"
              ref="table0"
              height="100%"
              :data="contracts.fpi.data"
              v-loading="contracts.loading"
              border
              stripe
              @selection-change="selectChange"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                prop="title"
                label="标题"
                width="145px"
                fixed
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="orderNum"
                label="工单编号"
                width="120px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="name" label="客户名称" width="100px"></el-table-column>
              <el-table-column prop="phone" label="客户电话" width="120px"></el-table-column>
              <el-table-column
                prop="province"
                label="省"
                :formatter="osg.formatProvince"
                width="100px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="city"
                label="市"
                :formatter="osg.formatCity"
                width="100px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="district"
                label="区"
                :formatter="osg.formatDistrict"
                width="100px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="address"
                label="详细地址"
                width="180px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="orgName"
                label="服务商"
                width="150px"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="createTime"
                label="创建时间"
                min-width="140px"
                sortable
              ></el-table-column>
              <el-table-column
                prop="paystate"
                label="支付状态"
                min-width="100px"
                :formatter="formatPayState"
              ></el-table-column>
              <el-table-column
                prop="unlockPayState"
                label="解付状态"
                min-width="100px"
                :formatter="formatUnlockPay"
              ></el-table-column>
              <el-table-column label="产品明细" width="500px">
                <template
                  slot-scope="scope"
                  v-if="scope.row.exts.productsSnap && scope.row.exts.productsSnap.length > 0"
                >
                  <el-table :data="scope.row.exts.productsSnap">
                    <el-table-column
                      prop="name"
                      label="规格"
                      width="150px"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column prop="price" label="单价"></el-table-column>
                    <el-table-column prop="costNum" label="数量"></el-table-column>
                  </el-table>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane> -->
        <!-- <el-tab-pane label="合同" name="contract" v-if="formData.sourceType == 2">
          <div class="box-center-tool">
            <el-tag type="success" size="medium">
              共查询到
              <span class="c_blue">{{ contracts.fpi.data.length }}</span>
              条符合条件的数据，已选择
              <span class="c_blue">{{ contracts.selectedRows.length }}</span>
              条。
            </el-tag>
            <div>
              <el-button type="primary" @click="doSave()" class="c-m-l-10">
                保存选则的合同
              </el-button>
            </div>
          </div>
          <div class="box-center-content">
            <el-table
              ref="table2"
              height="100%"
              :data="contracts.fpi.data"
              border
              stripe
              @selection-change="selectChange"
              v-loading="contracts.loading"
            >
              <el-table-column type="selection" width="55" fixed></el-table-column>
              <el-table-column
                prop="contactsName"
                label="委托方"
                min-width="150px"
                fixed
              ></el-table-column>
              <el-table-column prop="partyB" label="服务商" min-width="150px"></el-table-column>
              <el-table-column prop="signedDate" label="签订日期" width="100"></el-table-column>
              <el-table-column
                prop="contractdocNum"
                label="合同编号"
                min-width="170px"
                fixed
              ></el-table-column>
              <el-table-column
                prop="contactsPhone"
                label="联系电话"
                min-width="100px"
              ></el-table-column>
              <el-table-column prop="afterRefundMoney" label="合同金额(元)" min-width="100px">
                <template slot-scope="scope">
                  {{ scope.row.afterRefundMoney | toMoney }}
                </template>
              </el-table-column>
              <el-table-column prop="paidAmount" label="已支付金额(元)" min-width="110px">
                <template slot-scope="scope">
                  {{ scope.row.paidAmount | toMoney }}
                </template>
              </el-table-column>
              <el-table-column prop="teamLeader" label="工队长" min-width="100px"></el-table-column>
              <el-table-column
                prop="serviceHousekeeper"
                label="管家"
                min-width="100px"
              ></el-table-column>
              <el-table-column
                prop="exts.repairParts"
                label="维修部位"
                min-width="150px"
                :formatter="formatRepairParts"
              ></el-table-column>
              <el-table-column label="开工日期" min-width="90px">
                <template slot-scope="scope">
                  <span v-if="scope.row.startDate">
                    {{ scope.row.startDate.split(' ')[0] }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="完工日期" min-width="90px">
                <template slot-scope="scope">
                  <span v-if="scope.row.endDate">
                    {{ scope.row.endDate.split(' ')[0] }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="实际完工日期" min-width="100px">
                <template slot-scope="scope">
                  <span v-if="scope.row.exts.realCompleteDate">
                    {{ scope.row.exts.realCompleteDate.split(' ')[0] }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="exts.contractStatus"
                label="签约状态"
                min-width="100px"
                :formatter="formatContractStatus"
              ></el-table-column>
              <el-table-column
                prop="payState"
                label="支付状态"
                min-width="100px"
                :formatter="formatPayState"
              ></el-table-column>

            </el-table>
          </div>
        </el-tab-pane> -->
        <el-tab-pane label="任务明细" name="settleItem">
          <div class="box-center-tool">
            <div></div>
            <!-- <div>
                <el-button type="primary" @click="settleItem.open = true" class="c-m-l-10">
                  新增结算明细
                </el-button>
                <el-button
                  type="primary"
                  @click="
                    osg.export(
                      'settle',
                      {},
                      { hash: `/biz/settle/exportDetail/${id}.do`, noFilter: true }
                    )
                  "
                  class="c-m-l-10"
                >
                  导出
                </el-button>
              </div> -->
          </div>
          <div class="box-center-content settleTable">
            <el-table
              id="table-content"
              ref="TaskCustomerServices"
              highlight-current-row
              :data="formData.itemList"
              :default-sort="{
                prop: 'createTime',
                order: 'ascending'
              }"
              border
              stripe
              height="100%"
            >
              <!-- <el-table-column type="index" width="50"></el-table-column> -->
              <el-table-column prop="_id" label="任务id" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="任务名称" show-overflow-tooltip></el-table-column>
              <el-table-column prop="phone" label="客户电话"></el-table-column>
              <el-table-column
                property="taskStatus"
                label="任务状态"
                :formatter="formatTaskStatus"
              ></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="动态" name="log" v-if="false">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">
                {{ log.content }}
              </div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" v-if="false" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history" v-if="false">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 线下签约 上传附件 -->
    <el-dialog
      title="线下签约"
      :visible.sync="upload.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" label-width="130px">
        <el-form-item label="已签约文件">
          <el-upload
            :action="upload.url"
            :data="upload.data"
            :file-list="upload.fileList"
            :limit="1"
            :on-exceed="osg.uploadExceed"
            :before-upload="
              file => {
                return osg.beforeUpload(file);
              }
            "
            :on-success="
              (response, file, fileList) => {
                return (upload.fileList = osg.uploadSuccess(
                  response,
                  'upload',
                  fileList,
                  'fileList',
                  true
                ));
              }
            "
            :on-remove="
              () => {
                upload.fileList = [];
              }
            "
            :on-error="osg.uploadError"
            :on-preview="osg.uploadPreview"
          >
            <el-button size="small" type="primary">
              点击上传
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="offlineSigningConfirm()">确 定</el-button>
        <el-button @click="offlineSigningInit()">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 查看已签约文件列表 -->
    <el-dialog
      title="已签约文件列表"
      :visible.sync="signedDocumentsShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div v-for="(item, i) in formData.fileids" :key="i" class="c-m-b-10">
        <el-link :href="item" target="_blank">
          {{ item }}
        </el-link>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="signedDocumentsShow = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'Settle',
  data() {
    window.$this = this;
    return {
      id: null,
      collapse: true,
      activeCollapse: '1',
      formData: {
        datetimerange: [],
        sourceTypeIdList: [],
        contractCompleteTime: [],
        exts: {
          project_is: ''
        }
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      options: {
        codecfg_type: { codeId: 'settleType' },
        codecfg_sourceType: { codeId: 'taskSourceType' },
        codecfg_settleState: { codeId: 'settleState' },
        codecfg_contractSourceType: { codeId: 'sourceType' }, //信息来源
        cascadeCode_repairParts: { codeId: 'repairParts' },
        codecfg_contractStatus: { codeId: 'contractStatus' },
        codecfg_payState: { codeId: 'payState' },
        codecfg_unlockPay: { codeId: 'unlockPayState' },
        codecfg_contractSubject: { codeId: 'contractSubject' },
        codecfg_contractType: { codeId: 'contractType' },
        codecfg_deductType: { codeId: 'deductType' },
        codecfg_project_is: { codeId: 'project_is' },
        codecfg_adjustSubject: { codeId: 'adjustSubject' },
        codecfg_settleItemState: { codeId: 'settleItemState' },
        codecfg_taskStatus: {
          codeId: 'taskStatus'
        },
        users: []
      },
      rules: this.$util.rules,
      activeTab: 'settleItem',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      settleItem: {
        open: false, //新增结算明细模态窗
        formData: {},
        searchValue: ''
      },
      contracts: {
        fpi: {
          data: []
        },
        selectedRows: []
      },
      settleItemFields: [], // 结算明细表单字段
      upload: {
        id: '',
        show: false,
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        fileList: [],
        dialogImageUrl: '',
        dialogVisible: false
      },
      signedDocumentsShow: false,
      tenantId: '' //获取缓存租户id
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.id = this.osg.param('id');
    this.getUsers();
    // this.getPartners();
    // this.getOrgs();
    // this.getServiceResources();

    this.osg.getFields('settle', () => {
      this.getData();
    });
    this.osg.getFields('settleItem', () => {}, null, 'settleItemFields');
    this.getLog();
    this.getNote();
  },
  methods: {
    formatSourceType(row, column, cellValue) {
      return this.osg.codelabel('taskSourceType', cellValue);
    },
    formatSettleState(val) {
      return this.osg.codelabel('settleState', val);
    },
    formatDeductType(row, column, cellValue) {
      return this.osg.codelabel('deductType', cellValue);
    },
    formatSettleSourceType(val) {
      if (val || val == 0) {
        return this.osg.codelabel('sourceType', val.toString());
      }
    },
    formatRepairParts(row, column, cellValue) {
      if (cellValue) {
        return this.osg.formatCascade('repairParts', cellValue);
      }
    },
    formatContractStatus(row, column, cellValue) {
      if (!cellValue) {
        return '待签约';
      } else {
        return this.osg.codelabel('contractStatus', cellValue);
      }
    },
    formatPayState(row, column, cellValue) {
      return this.osg.codelabel('payState', cellValue);
    },
    formatUnlockPay(row, column, cellValue) {
      if (Array.isArray(cellValue)) {
        return cellValue.indexOf(Number(this.formData.type)) != -1 ? '已解付' : '未解付';
      } else {
        return this.osg.codelabel('unlockPay', cellValue);
      }
    },
    formatUserId(row, column, cellValue) {
      return this.osg.codelabel('serviceResources', cellValue);
    },
    formatTargetType(row, column, cellValue) {
      return cellValue == 1 ? '工单' : cellValue == 2 ? '合同' : cellValue;
    },
    formatSignDate(row, column, cellValue) {
      return cellValue ? this.$util.readableTime(cellValue, 'date') : '';
    },
    formatEndDate(row, column, cellValue) {
      return cellValue ? this.$util.readableTime(cellValue) : '';
    },

    formatTaskStatus(row, column, cellValue) {
      return this.osg.codelabel('taskStatus', cellValue, this);
    },
    getData() {
      this.osg.ajax(`/basic/supportHub/queryById/${this.id}.do`, {}, res => {
        res.itemList.map(item => {
          item.edit = false;
          item.exts = item.exts || {};
        });
        let row = res;
        row.exts = row.exts || {};
        this.$util.renderExtField(this.extFields, row);
        // 组装datetimerange
        if (row.startTime && row.endTime) {
          row.datetimerange = [row.startTime.split(' ')[0], row.endTime.split(' ')[0]];
        } else {
          row.datetimerange = [];
        }
        // 组装contractCompleteEndTime
        if (row.exts.contractCompleteStartTime && row.exts.contractCompleteEndTime) {
          row.contractCompleteTime = [
            row.exts.contractCompleteStartTime,
            row.exts.contractCompleteEndTime
          ];
        } else {
          row.contractCompleteTime = [];
        }
        row.toId = row.toId || ''; // 避免必填校验提前出现
        // row.exts.project_is = row.exts.project_is || ''; //是否工程类项目
        //结算单明细根据签订日期正序,如果没有签订日期则按照创建时间排序
        row.itemList.sort(
          (q, n) =>
            new Date((q.data && q.data.signedDate) || q.createTime) -
            new Date((n.data && n.data.signedDate) || n.createTime)
        );
        this.formData = row;
        this.contracts.unlockPayState = this.formData.unlockPayState;
        this.$nextTick(() => {
          //   this.$refs.settleItem && this.$refs.settleItem.setCurrentRow(this.formData.itemList[0]);
          this.$forceUpdate();
        });
        //获取属性修改记录
        this.getHistory();
      });
    },
    doSave() {
      if (this.formData.settleState != 0) {
        this.osg.alert('当前结算单状态不允许修改', () => {
          this.getData();
        });
        return;
      }
      if (this.osg.validate()) {
        this.formData.startTime = this.formData.startTime && this.formData.startTime + ' 00:00:00';
        this.formData.endTime = this.formData.endTime && this.formData.endTime + ' 23:59:59';
        // 结算来源id，targetType=0时为工单id，1时为订单id，2时为合同id
        let sourceTypeIdList = [];
        for (var item of this.contracts.selectedRows) {
          if (sourceTypeIdList.indexOf(item._id) == -1) sourceTypeIdList.push(item._id);
        }
        if (sourceTypeIdList.length == 0) {
          this.osg.alert('请至少勾选一条数据!');
          return;
        }
        this.formData.sourceTypeIdList = sourceTypeIdList;

        // 删除itemList非存储字段
        delete this.formData.itemList;
        this.$util.saveExtField(this.extFields, this.formData);

        // 付款方id（由结算对象来确定）
        switch (this.formData.type) {
          case 0:
            this.formData.fromId = '1340835581184723420';
            break;
          default:
            this.formData.fromId = '';
        }

        // 保存完工日期筛选条件
        if (this.formData.contractCompleteTime && this.formData.contractCompleteTime.length > 0) {
          this.formData.exts.contractCompleteStartTime = this.formData.contractCompleteTime[0];
          this.formData.exts.contractCompleteEndTime = this.formData.contractCompleteTime[1];
        }
        delete this.formData.contractCompleteTime;

        this.osg.ajax('biz/settle/upsert.do', this.formData, () => {
          this.osg.toast('保存成功！');
          this.getData();
        });
      }
    },
    tabClick(tab) {
      if (tab.name == 'contract') {
        this.filterConditionChange(true);
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'settle',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue);
      } else {
        return cellValue;
      }
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'settle'
        },
        res => {
          this.noteData = res || [];
        },
        { noload: true }
      );
    },
    saveNote() {
      var params = {
        sid: this.id,
        smodule: 'settle',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, () => {
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    // getOrgs() {
    //   var params = {
    //     _all: '1',
    //     'is:state|integer#and': 1,
    //     sortField: 'createTime',
    //     sortOrder: 'desc'
    //   };
    //   this.osg.ajax(
    //     'org/query.do',
    //     params,
    //     res => {
    //       res.data.orgList.map(item => {
    //         item.label = item.orgName;
    //         item.value = item._id;
    //       });
    //       this.options.orgs = res.data.orgList;
    //       this.$forceUpdate();
    //     },
    //     {
    //       noload: true
    //     }
    //   );
    // },
    // getPartners() {
    //   var params = {
    //     _all: '1',
    //     'in:state|array-integer#and': '0,1',
    //     sortField: 'createTime',
    //     sortOrder: 'desc'
    //   };
    //   this.osg.ajax(
    //     'basic/partner/query.do',
    //     params,
    //     res => {
    //       res.data.map(item => {
    //         item.label = item.name;
    //         item.value = item.orgId;
    //       });
    //       this.options.partners = res.data;
    //       this.$forceUpdate();
    //     },
    //     {
    //       noload: true
    //     }
    //   );
    // },
    // 获取服务资源-对工队结算
    // getServiceResources() {
    //   this.osg.ajax(
    //     'biz/serviceResource/query.do',
    //     {
    //       _all: '1',
    //       'is:state|integer#and': '1',
    //       resourceType: 'technician'
    //     },
    //     res => {
    //       res.data.map(item => {
    //         item.label = item.name;
    //         item.value = item.relatedRecordId;
    //       });
    //       this.options.serviceResources = res.data;
    //     }
    //   );
    // },
    filterConditionChange(edit, field) {
      if (!this.formData.sourceType && this.formData.sourceType != 0) {
        return;
      }
      // 将服务商名称赋值给结算单标题
      if (field == 'toId') {
        let partners = this.options.partners.filter(item => item.value == this.formData.toId);
        if (partners.length) {
          this.$set(this.formData, 'title', partners[0].name);
        }
      }

      // 结算来源类型:工单
      if (this.formData.sourceType == 0) {
        this.getServiceAppointments(edit);
        return;
      }

      // 结算来源类型:合同
      if (this.formData.sourceType == 2) {
        this.getContracts(edit);
        return;
      }

      // 结算来源类型:支付记录（结算明细）
      // if (this.formData.sourceType == 3) {
      //   this.getSettleItems(edit);
      //   return;
      // }
    },
    // 查询工单
    getServiceAppointments(edit) {
      // if (!this.formData.toId) {
      //   return;
      // }
      if (this.formData.datetimerange) {
        this.formData.startTime = this.formData.datetimerange[0];
        this.formData.endTime = this.formData.datetimerange[1];
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }
      // 赋值contractCompleteTime
      this.formData.contractCompleteTime = this.formData.contractCompleteTime || [];

      this.contracts.loading = true;
      var params = {
        _all: '1',
        'gte:createTime|datetime#and':
          this.formData.startTime && this.formData.startTime + ' 00:00:00',
        'lte:createTime|datetime#and': this.formData.endTime && this.formData.endTime + ' 23:59:59',
        // 'gte:exts.realCompleteDateTime|datetime#and': this.formData.contractCompleteTime[0]
        //   ? this.formData.contractCompleteTime[0] + ' 00:00:00'
        //   : null,
        // 'lte:exts.realCompleteDateTime|datetime#and': this.formData.contractCompleteTime[1]
        //   ? this.formData.contractCompleteTime[1] + ' 23:59:59'
        //   : null,
        'nin:settlePayState|array-integer#or': this.formData.type,
        // 'in:_id|array#or': edit ? this.formData.sourceTypeIdList.join() : null,
        'in:_id|array#or': this.formData.sourceTypeIdList
          ? this.formData.sourceTypeIdList.join()
          : null,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      if (this.contracts.unlockPayState) {
        params['in:unlockPayState|array-integer#and'] = this.formData.type;
      } else {
        params['nin:unlockPayState|array-integer#and'] = this.formData.type;
      }

      if (this.formData.type == 1) {
        // 平台对工人结算
        params['is:exts.headManId|string#and'] = this.formData.toId;
      } else {
        // 平台对门店结算
        params['is:orgId|string#and'] = this.formData.toId;
      }

      // 新增未解付结算单页面，只展示支付了金额的合同
      // if (!this.contracts.unlockPayState) {
      //   params['in:payState|array-integer#and'] = '1,2';
      // }
      // 合同类型
      if (this.formData.sourceType == 2) {
        // exts中数组不能传
        this.formData.sourceTypeType = this.formData.sourceTypeType || [];
        // params['in:contractType|array#and'] = this.formData.sourceTypeType.toString();
        params['in:contractType|array#and'] = this.formData.sourceTypeType.toString();
      }
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        params,
        res => {
          this.contracts.fpi = res;
          this.contracts.loading = false;
          this.$nextTick(() => {
            this.$refs.table0.doLayout();

            if (edit) {
              // 编辑结算单时 默认只勾选已选中的
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection(rows);
            } else {
              // 默认选中全部
              this.toggleSelection(res.data);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    // 查询合同
    getContracts(edit) {
      if (!this.formData.toId) {
        return;
      }

      if (this.formData.datetimerange) {
        this.formData.startTime = this.formData.datetimerange[0];
        this.formData.endTime = this.formData.datetimerange[1];
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }

      // 赋值contractCompleteTime
      this.formData.contractCompleteTime = this.formData.contractCompleteTime || [];

      this.contracts.loading = true;

      var params = {
        _all: '1',
        'gte:signedDate|datetime#and':
          this.formData.startTime && this.formData.startTime + ' 00:00:00',
        'lte:signedDate|datetime#and': this.formData.endTime && this.formData.endTime + ' 23:59:59',
        'gte:exts.realCompleteDateTime|datetime#and': this.formData.contractCompleteTime[0]
          ? this.formData.contractCompleteTime[0] + ' 00:00:00'
          : null,
        'lte:exts.realCompleteDateTime|datetime#and': this.formData.contractCompleteTime[1]
          ? this.formData.contractCompleteTime[1] + ' 23:59:59'
          : null,
        'nin:settlePayState|array-integer#or': this.formData.type,
        'in:_id|array#or': edit ? this.formData.sourceTypeIdList.join() : null,
        'in:exts.sourceType|string#and': this.formData.exts.contractSourceType, //用于过滤合同的信息来源
        'is:partnerId|string#and': this.formData.toId,
        'exists:exts.settleMark|boolean#and': false,
        'in:state|array-integer#and': '1,0',
        // 加条件 settledCandidate 不等于0
        'exists:settledCandidate|boolean#and': true,
        'ne:settledCandidate|integer#and': 0,

        sortField: 'createTime',
        sortOrder: 'desc'
      };

      // if (this.contracts.unlockPayState) {
      //   params['in:unlockPayState|array-integer#and'] = this.formData.type;
      // } else {
      //   params['nin:unlockPayState|array-integer#and'] = this.formData.type;
      // }

      // 是否工程类项目
      if (this.formData.exts.project_is == '0') {
        params['ne:exts.project_is|string#and'] = '1';
      } else if (this.formData.exts.project_is == '1') {
        params['is:exts.project_is|string#and'] = '1';
      }

      // 新增未解付结算单页面，只展示支付了金额的合同
      if (!this.formData.unlockPayState) {
        params['in:payState|array-integer#and'] = '1,2';
      }
      // 合同类型
      if (this.formData.sourceType == 2) {
        this.formData.sourceTypeType = this.formData.sourceTypeType || [];
        params['in:contractType|array#and'] = this.formData.sourceTypeType.toString();
      }
      this.osg.ajax(
        'basic/contract/query.do',
        params,
        res => {
          this.contracts.fpi = res;
          this.contracts.loading = false;
          this.$nextTick(() => {
            this.$refs.table2.doLayout();
            if (edit) {
              // 编辑结算单时 默认只勾选已选中的
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection(rows);
            } else {
              // 默认选中全部
              this.toggleSelection(res.data);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    // 查询考勤表
    getSign(edit) {
      // if (!this.formData.toId) {
      //   return;
      // }
      if (this.formData.datetimerange) {
        this.formData.startTime = this.formData.datetimerange[0];
        this.formData.endTime = this.formData.datetimerange[1];
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }

      this.contracts.loading = true;
      var params = {
        _all: '1',
        'gte:createTime|datetime#and':
          this.formData.startTime && this.formData.startTime + ' 00:00:00',
        'lte:createTime|datetime#and': this.formData.endTime && this.formData.endTime + ' 23:59:59',
        'nin:settlePayState|array-integer#or': this.formData.type,
        'in:_id|array#or': this.formData.sourceTypeIdList
          ? this.formData.sourceTypeIdList.join()
          : null,
        'is:userId|string#and': this.formData.toId,
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      if (this.contracts.unlockPayState) {
        params['in:unlockPayState|array-integer#and'] = this.formData.type;
      } else {
        params['nin:unlockPayState|array-integer#and'] = this.formData.type;
      }

      this.osg.ajax(
        '/biz/sign/sign/query.do',
        params,
        res => {
          this.contracts.fpi = res;
          this.contracts.loading = false;
          this.$nextTick(() => {
            this.$refs.table3.doLayout();

            if (edit) {
              // 编辑结算单时 默认只勾选已选中的
              let rows = [];
              res.data.map(item => {
                if (this.formData.sourceTypeIdList.indexOf(item._id) != -1) rows.push(item);
              });
              this.toggleSelection(rows);
            } else {
              // 默认选中全部
              this.toggleSelection(res.data);
            }
            this.$forceUpdate();
          });
        },
        {
          noload: true
        }
      );
    },
    // 指定选中合同
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          if (this.$refs['table' + this.formData.sourceType])
            this.$refs['table' + this.formData.sourceType].toggleRowSelection(row);
        });
        this.$forceUpdate();
      } else {
        if (this.$refs['table' + this.formData.sourceType])
          this.$refs['table' + this.formData.sourceType].clearSelection();
      }
    },
    // 选中合同行变化时触发
    selectChange(rows) {
      this.contracts.selectedRows = rows;
    },

    doSaveItem(row, uncheck) {
      let params = {};
      if (row) {
        // 编辑
        if (!uncheck) {
          if (!row.adjustSubject) {
            this.osg.toast('请选择调整科目!', 'warning');
            return;
          }
          if (!row.adjustAmount && row.adjustAmount != 0) {
            this.osg.toast('请输入调整金额!', 'warning');
            return;
          }
          if (!row.adjustRemark) {
            this.osg.toast('请输入调整备注!', 'warning');
            return;
          }
        }
        params = row;
        if (this.tenantId == '3427214598959251213') {
          delete params.type;
        }
        delete params.edit;
        delete params.rules;
        delete params.data;
      } else {
        // 新增
        if (this.osg.validate('settleItemForm')) {
          this.settleItem.formData.type = Number(this.formData.type);
          this.settleItem.formData.settleId = this.formData._id;
          params = this.settleItem.formData;
          if (this.tenantId == '3427214598959251213') {
            delete params.type;
          }
        } else {
          return;
        }
      }
      this.osg.ajax(
        'biz/settleItem/upsert.do',
        params,
        () => {
          this.doInit();
          this.osg.toast('保存成功！');
          this.getData();
        },
        {
          noload: true
        }
      );
    },
    doClearItem(row) {
      this.osg.confirm('是否确认清空“调整科目”、“调整金额”、“调整备注”？', () => {
        delete row.adjustSubject;
        row.adjustAmount = 0;
        delete row.adjustRemark;
        this.doSaveItem(row, true);
      });
    },
    doInit() {
      this.settleItem = {
        open: false,
        formData: { toId: '' },
        searchValue: ''
      };
    },
    doEdit(row) {
      row = this.$util.deepCopy(row); //避免编辑内容后取消导致显示异常
      delete row.edit;
      row.toId = row.toId || ''; // 避免必填校验提前出现
      this.settleItem.formData = row;
      this.doSaveItem();
    },
    doUnbind(id) {
      this.osg.confirm('是否确认解绑？', () => {
        this.osg.ajax(
          `biz/settleItem/unBind/${id}.do`,
          null,
          () => {
            this.osg.toast('解绑成功');
            this.getData();
          },
          {
            noload: true
          }
        );
      });
    },
    // 刷新结算明细解绑
    doUnbindSX(id) {
      this.osg.confirm('是否确认解绑？', () => {
        this.osg.ajax(
          `/unbindSettleSX/${id}.do`,
          null,
          () => {
            this.osg.toast('解绑成功');
            this.getData();
          },
          {
            noload: true
          }
        );
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(
          `biz/settleItem/remove/${id}.do`,
          null,
          () => {
            this.osg.toast('删除成功');
            this.getData();
          },
          {
            noload: true
          }
        );
      });
    },
    doSearch() {},
    getSummaryTotal(param) {
      const { columns, data } = param;
      const sums = [];
      let arr = ['amountOrigin', 'settleItemAmount', 'adjustAmount', 'amount']; //需要合计的字段
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (arr.indexOf(column.property) !== -1) {
          let total = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = this.settleToMoney(total); //保留两位小数点
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    //复制filter的代码-用于保留两位小数
    settleToMoney(val) {
      if (!val) {
        return 0;
      } else {
        val = Number(val).toFixed(2);
        let reg = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
        return val.toString().replace(reg, '$1,');
      }
    },
    /**
     * 签约状态：'0':待签约 '10':已签约
     */
    // 线上签约
    onlineSigning() {
      this.osg.ajax('biz/settle/signatureSettle.do', { id: this.formData._id }, () => {
        this.osg.toast('已发起签约');
        this.getData();
      });
    },
    // 线下签约
    offlineSigning() {
      this.upload.show = true;
    },
    offlineSigningConfirm() {
      if (this.upload.fileList.length == 0) {
        this.osg.toast('请先上传已签约文件');
        return;
      }
      if (!this.upload.fileList[0].response) {
        this.osg.toast('请等待文件上传完成再提交');
        return;
      }
      this.osg.ajax(
        'biz/settle/uploadSettlePdf.do',
        {
          id: this.formData._id,
          settlePdfUrl: this.upload.downloadUrl + this.upload.fileList[0].response.key
        },
        () => {
          this.osg.toast('线下签约成功');
          this.getData();
        }
      );
    },
    offlineSigningInit() {
      this.upload.show = false;
      this.upload.data = {};
      this.upload.fileList = [];
    },
    viewSignedDocuments() {
      if (this.formData.fileids.length == 1) {
        window.open(this.formData.fileids[0], '_blank');
      } else {
        this.signedDocumentsShow = true;
      }
    },
    getUsers() {
      this.osg.ajax(
        'user/query.do',
        {
          _all: '1',
          notFilterOrgId: '1',
          notFilterBelongTo: '1',
          'in:roleIds|array#and': '812337714845629049'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.users = res.data;
          console.log(this.options.users, '---this.options.users');
        },
        { noload: true }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.box-left {
  min-width: 350px !important;
}
</style>
<style>
.settleTable .el-table__body-wrapper {
  height: calc(100% - 80px) !important;
}
</style>
